import React, { useEffect, useState } from "react";
import Dialog from "components/Dialog/Dialog";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { actions as RequiredGearActions, selectors as RequiredGearSelectors } from "store/modules/requiredGear";

const style = ({ spacing }) => ({
    container: {
        marginBottom: spacing(2)
    }
})

function EditGearDialog({ classes, gear, onHideEditDialog }) {

    const dispatch = useDispatch();
    const [englishGearName, setEnglishGearName] = useState("");
    const [frenchGearName, setFrenchGearName] = useState("");
    const [gearStatus, setGearStatus] = useState(true);
    const isEditGearDialog = useSelector(RequiredGearSelectors.getIsEditGearDialog);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (gear) {
            setEnglishGearName(gear.gearName);
            setFrenchGearName(gear.frenchGearName);
            setGearStatus(gear.isActive);
        }
    }, [gear]);

    // const gearStatusValue = [
    //     {
    //         value: true,
    //         label: "Active"
    //     },
    //     {
    //         value: false,
    //         label: "Inactive"
    //     }
    // ]

    const hideEditGearDialog = () => {
        dispatch(RequiredGearActions.setIsEditGearDialog(false));
        onHideEditDialog();
    }

    const handleChangeEnglishGear = (event) => {
        setEnglishGearName(event.target.value);
    }

    const handleChangeFrenchGear = (event) => {
        setFrenchGearName(event.target.value);
    }

    const editGear = async () => {
        setIsLoading(true);
        const values = {
            id: gear.id,
            gearName: englishGearName,
            frenchGearName: frenchGearName,
            isActive: gearStatus
        }
        await dispatch(RequiredGearActions.updateRequiredGear(values)).then((res) => {
            if (res && res.updateGear) {
                setEnglishGearName("");
                setFrenchGearName("");
                setGearStatus(true);
                onHideEditDialog();
            }
        });
        setIsLoading(false)
    }

    // const onGearStatusChange = (event) => {
    //     setGearStatus(event.target.value)
    // }


    return (
        <Dialog
            open={isEditGearDialog}
            title="Edit Gear"
            onClose={hideEditGearDialog}
            onCancel={hideEditGearDialog}
            onConfirm={editGear}
            disabled={!englishGearName?.trim() || !frenchGearName?.trim() || isLoading}
            alertType="form"
            confirmText="Edit"
            size="sm"
            modalType="scrollable"
        >
            <div className={classes.container}>
                <TextField
                    id="englishGearName"
                    margin="normal"
                    label="Gear Name In English"
                    value={englishGearName}
                    onChange={handleChangeEnglishGear}
                    required
                    fullWidth
                />
                <TextField
                    id="frenchGearName"
                    margin="normal"
                    label="Gear Name In French"
                    value={frenchGearName}
                    onChange={handleChangeFrenchGear}
                    required
                    fullWidth
                />
                {/* <TextField
                    select
                    label="Gear Status"
                    value={gearStatus}
                    onChange={onGearStatusChange}
                    margin="normal"
                    fullWidth
                    required
                >
                    {gearStatusValue.map(({ value, label }) => (
                        <MenuItem key={`gearStatus-${value}`} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </TextField> */}
            </div>
        </Dialog>
    )
}

export default (withStyles(style)(EditGearDialog))
